import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import { spcFreeZoneApi } from "../../api/spcFreeZone";
import "./spcFreeZone.css";

export default function SpcFreeZoneHome() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setFailed(false);
    spcFreeZoneApi.home(controller.signal).then(result => {
      if (!controller.signal.aborted) setData(result);
    }).catch(error => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, [retry]);
  if (failed) return <section className="container spc-free-zone-home"><p role="status">Unable to load SPC Free Zone Packages. <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setRetry(value => value + 1)}>Retry</button></p></section>;
  if (!data || !data.visible || !data.products.length) return null;
  return <section className="spc-free-zone-home" aria-label={data.title}>
    <BlockProductsCarousel title={data.title} subtitle={data.subtitle} layout="grid-4" products={data.products} />
    <div className="container spc-free-zone-home__more"><Link className="btn btn-primary" to="/spc-free-zone-packages">View More <span aria-hidden="true">→</span></Link></div>
  </section>;
}
